<template>
  <section class="page-user-faq py-5">
    <app-loading :isFull="true" v-if="isLoading" />
    <vue-modaltor
      :visible="isModal"
      @hide="hideModal"
      :default-width="'50%'"
      :bg-overlay="'rgba(0, 0, 0, 0.7)'"
      :resize-width="{1200:'60%',992:'80%',768:'90%'}"
    >
      <app-loading :isFull="false" v-if="isLoading" />
      <div class="col-12">
        <div class="editor rtl text-right my-4">
          <label class="statr">جواب را وارد کنید</label>
          <tinymce-editor
            v-model="formDiscussReplyNew.content"
            api-key="5jvyaeru3nfs1qb04au0hymmsfyrhspqo7qg0xp8cnc8ptl6"
            :init="configMedia"
          ></tinymce-editor>
        </div>
      </div>
      <div class="col-12">
        <div class="form-action mt-2">
          <button
            class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
            v-ripple
            @click="postDiscussReplyNew"
          >ارسال جواب</button>
        </div>
      </div>
    </vue-modaltor>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <discuss-list
            v-if="listDiscuss.length"
            class="mb-4"
            :title="'پرسش و پاسخ های مطرح شده'"
            :items="listDiscuss"
            @replyDiscuss="openReplyDiscuss"
            @getDiscussReply="getDiscussReply"
          />
        </div>
        <div class="col-12">
          <div class="col-12">
            <b-card>
              <div class="col-12 col-md-4">
                <div class="group-form">
                  <input
                    type="text"
                    v-validate="'required'"
                    name="title"
                    :class="{active:faqForm.title != '' }"
                    v-model="faqForm.title"
                  />
                  <span class="bar"></span>
                  <label class="statr">عنوان</label>
                  <span v-if="errors.has('title')" class="is-danger">فیلد نباید خالی باشد</span>
                </div>
              </div>
              <div class="col-12">
                <div class="editor rtl text-right my-4">
                  <label class="statr">پرسش خود را مطرح کنید</label>
                  <tinymce-editor
                    v-model="faqForm.content"
                    api-key="5jvyaeru3nfs1qb04au0hymmsfyrhspqo7qg0xp8cnc8ptl6"
                    :init="configMedia"
                  ></tinymce-editor>
                </div>
              </div>
              <div class="col-12">
                <div class="form-action mt-2">
                  <button
                    class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
                    v-ripple
                    @click="postDiscussNew"
                  >ارسال سوال</button>
                </div>
              </div>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import contactForm from "cp/contact-form.vue";
import discussList from "cp/list-discuss.vue";

export default {
  name: "page-user-discuss",
  components: {
    contactForm,
    discussList
  },
  data() {
    return {
      page: 1,
      isModal: false,
      isLoading: false,
      faqForm: {
        title: "",
        content: ""
      },
      formDiscussReplyNew: {
        content: ""
      },
      activeDiscuss: {}
    };
  },
  computed: {
    courseId() {
      return this.$route.params.id;
    },
    listDiscuss() {
      return this.$store.state.contentCourses.listDiscuss;
    }
  },
  mounted() {
    this.discussGet(this.page);
  },
  methods: {
    hideModal() {
      this.isModal = false;
      this.activeDiscuss = {};
      this.formDiscussReplyNew.content = "";
    },
    async discussGet(p) {
      this.isLoading = true;
      this.page = p | 1;
      await this.$store.dispatch("contentCourses/discussGet", {
        course: parseInt(this.courseId),
        page_num: this.page
      });
      this.isLoading = false;
    },
    async postDiscussNew() {
      this.isLoading = true;
      await this.$store.dispatch("contentCourses/postDiscussNew", {
        ...this.faqForm,
        course: parseInt(this.courseId)
      });
      this.isLoading = false;
      this.faqForm = {
        title: "",
        content: ""
      };
      this.$validator.reset();
      this.discussGet(1);
    },
    openReplyDiscuss(item, index) {
      this.isModal = true;
      this.activeDiscuss = { item, index };
    },
    async postDiscussReplyNew() {
      this.isLoading = true;
      let formDiscussReplyNew = this.formDiscussReplyNew;
      formDiscussReplyNew.discuss = parseInt(this.activeDiscuss.item.id);
      await this.$store.dispatch("contentCourses/discussReplyNew", {
        formDiscussReplyNew,
        index: this.activeDiscuss.index
      });
      this.isLoading = false;
      this.getDiscussReply({
        item: this.activeDiscuss.item,
        index: this.activeDiscuss.index
      });
      this.hideModal();
    },
    async getDiscussReply(item, index) {
      this.isLoading = true;
      await this.$store.dispatch("contentCourses/getDiscussReply", {
        discuss_id: item.id,
        index,
        id:item.id
      });
      this.isLoading = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/courses/_en_category/_en_subcategory/_id/_course_title_encourses/discuss/index.vue